import type { ReactNode } from "react";
import type { BasicSuccessPageForDataFormProps } from "@/component/assets/AbstractLeadForm/Steps/BasicSuccessPageForDataForm";
import { BasicSuccessPageForDataForm } from "@/component/assets/AbstractLeadForm/Steps/BasicSuccessPageForDataForm";

interface Props extends BasicSuccessPageForDataFormProps {
	variant?: string;
}

export class SuccessPage extends BasicSuccessPageForDataForm<{}, Props> {
	public static defaultProps = {
		...BasicSuccessPageForDataForm.defaultProps,
		relativeUrl: "/lakashitel-kalkulator/adatbekero",
	};

	protected renderDataFormFooter(buttonTitle?: string): ReactNode {
		const { variant } = this.props;
		switch (variant) {
			case "freeUse":
				return super.renderDataFormFooter("Gyorsított jelzáloghitel");
			default:
				return super.renderDataFormFooter(buttonTitle);
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
